import { MediaSynchronizer } from './classes/MediaSynchronizer'

export default {
  install(Vue, queries) {
    let sync = new MediaSynchronizer(Vue, queries)
    Vue.prototype.$media = sync.media
  }
}



// WEBPACK FOOTER //
// ./src/plugins/vue-media-sync/index.js